import { render } from "./ProfilForm.vue?vue&type=template&id=4fea13b9"
import script from "./js/profilForm.js?vue&type=script&lang=js&external"
export * from "./js/profilForm.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__